import { render, staticRenderFns } from "./PreGoToPage2Modal.vue?vue&type=template&id=912afa82"
import script from "./PreGoToPage2Modal.vue?vue&type=script&lang=js"
export * from "./PreGoToPage2Modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports